import React, { useEffect, useRef, useState } from "react";
import { CInput, Txt } from "./generalComponets";
import Select, { components } from "react-select";
import { Label } from "./elements";

const LimitedChipsContainer = ({ children, hasValue, ...props }) => {
  if (!hasValue) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  }
  const CHIPS_LIMIT = 1;
  const [chips, otherChildren] = children;
  const overflowCounter = chips.slice(CHIPS_LIMIT).length;
  const displayChips = chips.slice(overflowCounter, overflowCounter + CHIPS_LIMIT);

  return (
    <components.ValueContainer {...props}>
      {chips.length} Selected
      {/* {displayChips} */}
      {/* {overflowCounter > 0 && `+ ${overflowCounter}`} */}
      {/* {otherChildren} */}
    </components.ValueContainer>
  );
};

export const SearchPicker = ({
  title,
  onChange,
  value,
  field = "name",
  mt = 0,
  ml = 0,
  mr = 0,
  mb = 0,
  style,
  fl,
  list = [],
  value_field = "id",
  onEnterPress,
  focus,
  err,
  AddSelect,
  AddAll = false,
  onAddClick,
  closeMenuOnSelect = true,
  hideSelectedOptions = false,
  isSearchable = true,
  isMulti = false,
  disableLimitedChip = false,
}) => {
  let options = list;
  if (AddSelect) {
    options = [{ id: "Select", name: "Select" }, ...list];
  }
  if (AddAll) {
    options = [{ id: "All", name: "All" }, ...list];
  }
  const inref = useRef();
  const t_focus = () => {
    inref.current.focus();
  };
  options.map((it) => {
    it.label = it[field];
    it.value = it[value_field];
  });
  useEffect(() => {
    if (focus) {
      focus(() => {
        t_focus();
      });
    }
  }, []);

  const multiValueContainer = ({ selectProps, data }) => {
    const label = data.label;
    const allSelected = selectProps.value;
    const index = allSelected.findIndex((selected) => selected.label === label);
    const isLastSelected = index === allSelected.length - 1;
    const labelSuffix = isLastSelected ? ` (${allSelected.length})` : ", ";
    const val = `${labelSuffix} Selected`;
    return "a";
  };
  return (
    <div
      style={{
        flex: fl ? 1 : null,
        marginTop: mt,
        marginLeft: ml,
        marginRight: mr,
        marginBottom: mb,
        ...style,
      }}
    >
      <div className="fl" style={{ justifyContent: "space-between" }}>
        <Label style={{ textAlign: "left" }} className="mc-label-field-title">
          {title}
        </Label>
        {onAddClick ? (
          <p onClick={onAddClick} className="mg-b-5 aligtnLeft addclicktext">
            + Add New {title}
          </p>
        ) : null}
      </div>

      <Select
        options={options}
        onChange={onChange}
        value={value}
        isMulti={isMulti}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        isSearchable={isSearchable}
        defaultValue={value}
        components={
          disableLimitedChip
            ? {}
            : {
                // MultiValueContainer: multiValueContainer,
                ValueContainer: LimitedChipsContainer,
                // MultiValueLabel:multiValueContainer
                // MultiValueRemove:multiValueContainer
                // Option: CustomOption,
              }
        }
        styles={{
          control: (provided) => {
            return {
              ...provided,
              borderRadius: 8,
              borderColor: err ? "red" : "#ddd",
              borderWidth: 0.5,
              backgroundColor: "#EEE",
              height: 42,
            };
          },
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (onEnterPress) {
              onEnterPress();
            }
          }
        }}
        ref={inref}
      />
      {err ? (
        <Txt s={12} c="r">
          {err}
        </Txt>
      ) : null}
    </div>
  );
};
